import Api from '@/api'
// eslint-disable-next-line prettier/prettier
import type { Commit } from 'vuex'
import type { FetchParamsType } from '@/utilities/bid/fetches/types/FetchParamsType'
import type { BidItemType } from '@/api/types/general/BidType'
import type { GridManagerResponseType } from '@/api/types/response/GridManagerResponseType'

export default class Summary {
  async fetch(commit: Commit, params: FetchParamsType): Promise<GridManagerResponseType<BidItemType> | BidItemType[]> {
    try {
      const {
        data: {
          data: { summary },
        },
      } = await new Api().fetchBidListByType(this.buildUrl(params))
      return summary
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
      return []
    }
  }

  buildUrl({ bidNumber = '', type = '', ...queryParams }: FetchParamsType): string {
    let url = '/api/sales/bid/summary'
    // @todo it is an OR option rather than AND
    url += bidNumber ? '/' + bidNumber : ''
    url += type ? '/' + type : ''
    url += '?' + new URLSearchParams(queryParams).toString()

    return url
  }
}
